import List from "./List";

const LeftNavWithButtons = ({
    listData,
    listAttr = "name",
    listOnClick,
    selectedTab = "",
    disabled,
    buttons
}) => {
    return <div className="sticky-lg-top mt-3 pb-2">
        <div className="row pb-2" style={{ flexDirection: "column" }}>
            <div className="fs-7 config-list">
                {listData && <List
                    onClick={(selectedItem) => {
                        if (!disabled) {
                            listOnClick(selectedItem)
                        }
                    }}
                    attr={listAttr}
                    data={listData}
                    selectedElement={selectedTab.toLowerCase()}
                />}
            </div>
        </div>
        {buttons && <div className="row border-top border-accenture">
            {buttons}
        </div>}
    </div>
}

export default LeftNavWithButtons;